<div class="page-header-container">
    <div class="page-header-title" [class.update-logo]="useNewUiForBank">
        <img *ngIf="hasHeaderImage()" src="data:image/jpeg;base64,{{ institution.logo }}" class="main-logo" />
    </div>

    <!-- TODO: RESKIN - need "save & resume later" button here on interior pages -->

    <section *ngIf="showText" [innerHTML]="getHtml()" class="page-header-content" [class.update-pagetext]="useNewUiForBank"></section>
    
</div>